<ng-content></ng-content>
<div class="row model-content" *ngIf="showModel">
  <div class="col-sm-12">
    <div class=" alert alert-info">
      <button type="button" class="close" aria-label="Close" (click)="onClose()">
        <span aria-hidden="true">&times;</span>
      </button>
      <h4>Model</h4>
      <pre>{{model|json}}</pre>
      <h4>Validation errors</h4>
      <pre>{{errors|json}}</pre>
    </div>
  </div>
</div>
